import siteType from "./siteType";

// const pcButton = ['Brazil', 'Maldive', 'Norway', 'Malaysia', 'South Korea']  // android, windows

// android, windows, apple
const threeDownloadButton = [
  "Canada",
  "Macedonia",
  "North Macedonia",
  "Peru",
  "Mexico",
  "Argentina",
  "Uruguay",
  "Costa Rica",
  "Chile",
  "Thailand",
  "Slovenia",
  "Israel",
  "India",
  "The United Arab Emirates",
  "Philippines",
  "New Zealand",
  "Colombia",
  "Bolivia",
  "Ecuador",
  "Venezuela"
];

const webCountrySet = new Set([
  // 曼島
  "Brazil",
  "Malaysia",
  "Maldive",
  "Norway",
  "Canada",
  // 庫拉索
  "South Korea"
]);

export function checkPlatform(platform, andriodOnly) {
  let result = {
    iphone: true,
    web: false
  };

  if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
    result.iphone = true
    result.web = true
  } else {
  if (andriodOnly.includes(platform)) {
    // Android & Windows
    result.iphone = false;
  }

  if (webCountrySet.has(platform)) {
    result.web = true;
  }
  }

  return result;
}
